<template>
  <div class="auth">
    <div class="auth-wrapper">
      <v-empty-state
        headline="Whoops, 404"
        title="Page not found"
        text="The page you were looking for does not exist"
      ></v-empty-state>
    </div>
  </div>
</template>
